var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { FieldArrayContext } from '../@common/field-array-context';
import { FormContext } from '../@common/form-context';
import NamedField from './named-field';
// измеряется в миллисекундах
var DEF_HIDE_ERROR_IN_X_SEC = 6000;
export function createField(optionsOrComponent, componentInSecondParam) {
    var _a;
    var options = componentInSecondParam
        ? typeof optionsOrComponent === 'object'
            ? optionsOrComponent
            : { fieldType: optionsOrComponent }
        : undefined;
    var fieldType = options ? (_a = options.fieldType) !== null && _a !== void 0 ? _a : undefined : undefined;
    var hideErrorInXSec = options
        ? typeof options.hideErrorInXSec !== 'undefined'
            ? options.hideErrorInXSec
            : DEF_HIDE_ERROR_IN_X_SEC
        : DEF_HIDE_ERROR_IN_X_SEC;
    var component = componentInSecondParam !== null && componentInSecondParam !== void 0 ? componentInSecondParam : optionsOrComponent;
    return function (_a) {
        var name = _a.name, validators = _a.validators, props = __rest(_a, ["name", "validators"]);
        return (React.createElement(FormContext.Consumer, null, function (formState) { return (React.createElement(FieldArrayContext.Consumer, null, function (fieldArrayState) {
            return (React.createElement(NamedField, { fieldArrayState: fieldArrayState, formState: formState, component: component, componentProps: props, providedName: name, type: fieldType, validators: validators, hideErrorInXSec: hideErrorInXSec }));
        })); }));
    };
}
